module.exports = __webpack_public_path__ + "img/sign-31.8f2f2cfe.jpg";